import { Component, Show } from 'solid-js';
import { translate } from '@fulcrum/lib';
import type { IExportJobDetail } from '@trimble/tc-issue-management-providers';
import { IssueExchangeStatus } from '../../types/issue.types';

export interface ExchangeJobStatusProps {
  item: IExportJobDetail;
  errorMessage: string;
}

export const ExchangeJobStatus: Component<ExchangeJobStatusProps> = (props) => {
  return (
    <>
      <Show when={props.item.status === IssueExchangeStatus.Cancelled}>
        <span class="ism-text-bold">
          {translate('TC.File.Upload.Status.Cancelled')}
        </span>
      </Show>
      <Show when={props.item.status === IssueExchangeStatus.Failed}>
        <span
          class="text-ellipsis ism-text-bold textRed"
          title={props.errorMessage}
        >
          {translate('TC.File.Upload.Status.Failed')}
        </span>
      </Show>
    </>
  );
};
